import { isMoment } from "moment";
export function encodeFilter(value) {
    if (value.length === 0)
        return "";
    return value.map(function (v) {
        var strVal = "";
        if (typeof v.value === "string") {
            strVal = v.value;
        }
        else if (isMoment(v.value)) {
            strVal = v.value.toJSON();
        }
        else { // @ts-ignore
            strVal = v.value.toString();
        }
        return v.key + v.operator + strVal;
    }).join(",");
}
